import { Button, Col, Form, Input, Modal, Row, Select, Typography } from "antd";
import ServiceApi from "apis/ServiceApi";
import { showNotification, validateEmailMulti } from "common";
import { filterOption } from "helpers/filterOption";
import React, { useEffect, useState } from "react";

export default function ModalExportInvoice({
  isOpen,
  setIsOpen,
  dataInfoCert,
  dataCheckReq,
  setIsExport
}) {
  const [form] = Form.useForm();
  const recipientType = Form.useWatch("recipientType", form);

  const [loading, setLoading] = useState(false);
  const [errorData, setErrorData] = useState({});
  const renderServerError = (message) =>
    message ? <Typography.Text type="danger">{message}</Typography.Text> : null;

  useEffect(() => {
    if (dataInfoCert) {
      form.setFieldValue("recipientType", dataInfoCert?.type);
      form.setFieldValue("fullAddress", dataInfoCert?.address);
      form.setFieldValue("email", [{ value: dataInfoCert?.email }]);
      switch (dataInfoCert?.type) {
        case 1:
        case 3:
          form.setFieldValue("taxCode", dataInfoCert?.code);
          form.setFieldValue("companyName", dataInfoCert?.name);

          break;
        case 2:
          form.setFieldValue("fullName", dataInfoCert?.name);
          form.setFieldValue("phoneNumber", dataInfoCert?.phone);
          break;
        default:
          break;
      }
    }
  }, [dataInfoCert]);

  const handleOk = () => {
    form.submit();
  };
  const handleCancel = () => {
    setIsOpen((pre) => !pre);
  };

  const OPTION_OBJECT_INVOICE = [
    { value: 1, label: "Tổ chức" },
    { value: 2, label: "Cá nhân" },
    { value: 3, label: "Hộ, cá nhân kinh doanh" },
  ];

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const newEmail = values.email.map((item) => item.value);
      const body = {
        ...values,
        email: newEmail,
        requestId: dataCheckReq?.id,
        object: dataCheckReq?.object,
      };
      form.setFieldValue("requestId", dataCheckReq?.id);
      form.setFieldValue("object", dataCheckReq?.object);
      const res = await ServiceApi.saveAndExportInvoice(body);
      if (res && res.status === 200 && res.data.status === 200) {
        showNotification(
          "success",
          "Hóa đơn sẽ được gửi trong 24h vào email đăng ký CTS của Quý khách",
          "Thành công"
        );
        setIsOpen((pre) => !pre);
        setIsExport(false)
      } else {
      }
    } catch (error) {
      if (error?.response?.status === 400) {
        const detailError = error?.response?.data?.detail;
        setErrorData(detailError);
      }
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Thông tin xuất hóa đơn"
      open={isOpen}
      onCancel={handleCancel}
      width={900}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Huỷ
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleOk}
        >
          Gửi yêu cầu xuất hoá đơn
        </Button>,
      ]}
    >
      <Form onFinish={onFinish} layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Đối tượng nhận hóa đơn"
              name="recipientType"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn đối tượng nhận hóa đơn!",
                },
              ]}
              extra={renderServerError(errorData?.recipientType)}
            >
              <Select
                showSearch
                placeholder="Chọn đối tượng nhận hóa đơn"
                optionFilterProp="children"
                filterOption={filterOption}
                allowClear
              >
                {OPTION_OBJECT_INVOICE.map((item, idx) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Email nhận hoá đơn (Nhập sau đó nhấn enter để thêm email)"
              name="email"
              rules={[
                {
                  type: "array",
                  required: true,
                  message: "Vui lòng nhập email nhận hoá đơn!",
                },
                {
                  validator: validateEmailMulti,
                },
              ]}
              extra={renderServerError(errorData?.email)}
            >
              <Select
                showSearch
                mode="tags"
                labelInValue
                placeholder="Nhập email nhận hóa đơn và nhấn enter"
                allowClear
              ></Select>
            </Form.Item>
          </Col>

          {recipientType === 2 ? (
            <>
              <Col span={12}>
                <Form.Item
                  label="Họ và tên"
                  name="fullName"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập Họ và tên!",
                    },
                  ]}
                  extra={renderServerError(errorData?.fullName)}
                >
                  <Input placeholder="Ví dụ: Nguyễn Văn A" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Số điện thoại"
                  name="phoneNumber"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập Số điện thoại!",
                    },
                  ]}
                  extra={renderServerError(errorData?.phoneNumber)}
                >
                  <Input placeholder="Ví dụ: 0198299XXX" />
                </Form.Item>
              </Col>
            </>
          ) : (
            <>
              <Col span={12}>
                <Form.Item
                  label="Mã số thuế"
                  name="taxCode"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập mã số thuế!",
                    },
                  ]}
                  extra={renderServerError(errorData?.taxCode)}
                >
                  <Input placeholder="Ví dụ: 0229198XXX" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Tên công ty"
                  name="companyName"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập tên công ty!",
                    },
                  ]}
                  extra={renderServerError(errorData?.companyName)}
                >
                  <Input placeholder="Ví dụ: Công ty A" />
                </Form.Item>
              </Col>
            </>
          )}

          <Col span={24}>
            <Form.Item
              label="Địa chỉ đầy đủ"
              name="fullAddress"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập địa chỉ đầy đủ",
                },
              ]}
              extra={renderServerError(errorData?.fullAddress)}
            >
              <Input placeholder="Ví dụ: Địa chỉ đầy đủ" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
